import { useState, useEffect, useCallback, useRef, useMemo } from 'react';
// import { useWebSocketData } from './useWebSocketData'; // Removed WebSocket hook import

const API_URL = '';  // Use relative URLs

// Helper function to capitalize first letter
// const capitalizeFirstLetter = (string) => { // This helper seems unused, removing
//   if (!string) return '';
//   return string.charAt(0).toUpperCase() + string.slice(1).toLowerCase();
// };

/**
 * Hook to fetch ACLED data
 * @param {Object} selectedView - The selected view object
 * @returns {Object} - ACLED data, loading state, and error state
 */
export const useACLEDData = (selectedView) => {
  const [acledData, setACLEDData] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);
  // const [lastUpdate, setLastUpdate] = useState(null); // Removed as it was tied to WebSocket updates

  // Get view code for WebSocket filtering - REMOVED
  // const viewCode = selectedView?.code?.toLowerCase();
  
  // Setup WebSocket data subscription with memoized filters - REMOVED
  // const wsFilters = useMemo(() => ({ view: viewCode }), [viewCode]);
  
  // const { 
  //   data: wsData, 
  //   isLoading: wsLoading, 
  //   error: wsError, 
  //   lastUpdate: wsLastUpdate,
  //   refreshData
  // } = useWebSocketData('acled', { // REMOVED
  //   autoRefresh: true,
  //   filters: wsFilters
  // });

  // Initial data fetch
  const fetchACLEDData = useCallback(async () => {
    if (!selectedView) {
      setACLEDData([]); // Clear data if no view
      setIsLoading(false);
      setError(null);
      return;
    }
    
    setIsLoading(true);
    setError(null);
    
    try {
      // Ensure selectedView.code is available
      if (!selectedView.code) {
        throw new Error('View code is missing');
      }
      const isoResponse = await fetch(`${API_URL}/api/views/${selectedView.code}/iso-code`);
      if (!isoResponse.ok) {
        throw new Error('Failed to fetch view ISO code');
      }
      const { iso_numeric } = await isoResponse.json();
      
      const endDate = new Date().toISOString().split('T')[0];
      // Fetch data for the last 180 days, adjust as needed
      const startDate = new Date(Date.now() - 180 * 24 * 60 * 60 * 1000).toISOString().split('T')[0];

      const response = await fetch(
        `${API_URL}/api/acled?views=${iso_numeric}&start_date=${startDate}&end_date=${endDate}`
      );
      
      if (!response.ok) {
        throw new Error('Failed to fetch ACLED data');
      }
      
      const data = await response.json();
      setACLEDData(data || []); // Ensure data is an array
    } catch (err) {
      console.error('Error fetching ACLED data:', err);
      setError(err.message);
      setACLEDData([]); // Clear data on error
    } finally {
      setIsLoading(false);
    }
  }, [selectedView]);

  // Initial fetch on view change
  useEffect(() => {
    fetchACLEDData();
  }, [fetchACLEDData]); // fetchACLEDData is stable due to useCallback

  // Track previous data and view to prevent unnecessary updates - REMOVED as it was for WebSocket
  // const wsDataRef = useRef(null);
  
  // Handle WebSocket data updates - REMOVED
  // useEffect(() => {
  //   if (wsData) {
  //     // Case 1: Import completion notification
  //     if (wsData._meta?.operation === 'import' && wsData._meta?.status === 'completed') {
  //       fetchACLEDData();
  //       return;
  //     }
      
  //     // Case 2: Data updates
  //     if (Array.isArray(wsData) && wsData.length > 0) {
  //       const wsDataString = JSON.stringify(wsData);
  //       if (wsDataString !== JSON.stringify(wsDataRef.current)) {
  //         wsDataRef.current = wsData;
          
  //         setACLEDData(prevData => {
  //           // For large updates, replace entire dataset
  //           if (wsData.length > 100) {
  //             return wsData;
  //           }
            
  //           // For smaller updates, merge with existing data
  //           const newData = [...prevData];
  //           wsData.forEach(wsItem => {
  //             const existingIndex = newData.findIndex(item => 
  //               item.id === wsItem.id || item.event_id_cnty === wsItem.event_id_cnty
  //             );
  //             if (existingIndex >= 0) {
  //               newData[existingIndex] = wsItem;
  //             } else {
  //               newData.push(wsItem);
  //             }
  //           });
  //           return newData;
  //         });
          
  //         setLastUpdate(wsLastUpdate);
  //         setIsLoading(false);
  //       }
  //     } else if (wsData.length === 0) {
  //       setIsLoading(false);
  //     }
  //   }
  // }, [wsData, wsLastUpdate, fetchACLEDData]);

  // Handle WebSocket errors - REMOVED
  // useEffect(() => {
  //   if (wsError) {
  //     setError(wsError);
  //   }
  // }, [wsError]);

  return { 
    acledData, 
    isLoading, // Simplified, was: isLoading || wsLoading 
    error,     // Simplified, was: error || wsError
    // lastUpdate, // Removed
    refreshData: fetchACLEDData // Simplified, was calling WebSocket refreshData as well
  };
};
